// extracted by mini-css-extract-plugin
export default {"inline_widget_container":"_27MbQ","inline_widget_heading":"tjJza","inline_widget_locations":"_35mHt","inline_widget_location_chips":"_2L2k4"};